import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export default new Router({
  mode: 'history',
  linkActiveClass: 'active',
  base: process.env.ROUTER_BASE || '',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  // base: '/client/',
  routes: [
    // partie public
    {
      path: '/',
      name: 'Accueil',
      component: resolve => require(['@/components/Home/Home'], resolve),
      meta: {
        forVisitors: true,
        title: 'Tendfox',
        metaTags: [
          {
            name: 'description',
            content: 'Tendfox est un outil qui permet d’avoir une vue globale sur l’économie algerienne, son actualité, l’ensemble des appels d\'offre et données financières.'
          },
          {
            property: 'og:description',
            content: 'Tendfox est un outil qui permet d’avoir une vue globale sur l’économie algerienne, son actualité, l’ensemble des appels d\'offre et données financières.'
          },
          {
            name: 'robots',
            content: 'index,follow'
          }
        ]
      }
    },
    {
      path: '/faq',
      name: 'foire au question',
      component: resolve => require(['@/components/faq'], resolve),
      meta: {
        forVisitors: true,
        title: 'Foire au question',
        metaTags: [
          {
            name: 'description',
            content: 'TENDFOX, le portail indispensable de veille sur les Marchés Publics et Privés en Algérie.'
          },
          {
            property: 'og:description',
            content: 'TENDFOX, le portail indispensable de veille sur les Marchés Publics et Privés en Algérie.'
          },
          {
            name: 'robots',
            content: 'index,follow'
          }
        ]
      }
    },
    {
      path: '/listentreprise',
      name: 'listentreprise',
      component: resolve => require(['@/components/entreprise/resutlatrecherche'], resolve),
      meta: {
        forVisitors: true,
        title: 'Annuaire des entreprises algeriennes',
        metaTags: [
          {
            name: 'description',
            content: 'TENDFOX, le portail indispensable de veille sur les Marchés Publics et Privés en Algérie.'
          },
          {
            property: 'og:description',
            content: 'TENDFOX, le portail indispensable de veille sur les Marchés Publics et Privés en Algérie.'
          },
          {
            name: 'robots',
            content: 'noindex, follow'
          }
        ]
      }
    },
    {
      path: '/listappeloffre',
      name: 'listappeloffre',
      component: resolve => require(['@/components/appeloffre/listappeloffre'], resolve),
      meta: {
        forVisitors: true,
        title: 'Annuaire des appels d\'offres',
        metaTags: [
          {
            name: 'description',
            content: 'Collecte et consultation quotidienne de tous les appels d\'offres et Marchés Publics et Privés en Algérie sur Tendfox.'
          },
          {
            property: 'og:description',
            content: 'Collecte et consultation quotidienne de tous les appels d\'offres et Marchés Publics et Privés en Algérie sur Tendfox'
          },
          {
            name: 'robots',
            content: 'noindex, follow'
          }
        ]
      }
    },
    {
      path: '/login',
      name: 'Connexion',
      component: resolve => require(['@/components/connexion'], resolve),
      meta: {
        forVisitors: true,
        title: 'Connexion tendfox',
        metaTags: [
          {
            name: 'description',
            content: 'TENDFOX, le portail indispensable de veille sur les Marchés Publics et Privés en Algérie.'
          },
          {
            property: 'og:description',
            content: 'TENDFOX, le portail indispensable de veille sur les Marchés Publics et Privés en Algérie.'
          },
          {
            name: 'robots',
            content: 'noindex, follow'
          }
        ]
      }
    },
    {
      path: '/register',
      name: 'Inscription',
      component: resolve => require(['@/components/inscription'], resolve),
      meta: {
        forVisitors: true,
        title: 'Inscription',
        metaTags: [
          {
            name: 'description',
            content: 'TENDFOX, le portail indispensable de veille sur les Marchés Publics et Privés en Algérie.'
          },
          {
            property: 'og:description',
            content: 'TENDFOX, le portail indispensable de veille sur les Marchés Publics et Privés en Algérie.'
          },
          {
            name: 'robots',
            content: 'noindex, follow'
          }
        ]
      }
    },
    {
      path: '/profil',
      name: 'Profil',
      component: resolve => require(['@/components/utilisateurs/profil'], resolve),
      meta: {
        forAuth: true
      }
    },
    {
      path: '/favoris',
      name: 'Favoris',
      component: resolve => require(['@/components/utilisateurs/favoris'], resolve),
      meta: {
        forAuth: true
      }
    },
    {
      path: '/tfabonnement',
      name: 'tfabonnement',
      component: resolve => require(['@/components/utilisateurs/tfabonnement'], resolve),
      meta: {
        forAuth: true
      }
    },
    {
      path: '/cdc',
      name: 'Cdc',
      component: resolve => require(['@/components/utilisateurs/cdc'], resolve),
      meta: {
        forAuth: true
      }
    },
    {
      path: '/notifications',
      name: 'Notifications',
      component: resolve => require(['@/components/utilisateurs/notifications'], resolve),
      meta: {
        forAuth: true
      }
    },
    {
      path: '/team',
      name: 'Gestion de la team',
      component: resolve => require(['@/components/utilisateurs/gestionTeam'], resolve),
      meta: {
        forAuth: false,
        forAdminTeam: false
      }
    },
    {
      path: '/profil/entreprise',
      name: 'Edition de l\'entreprise',
      component: resolve => require(['@/components/utilisateurs/editentreprise'], resolve),
      meta: {
        forAuth: true
      }
    },
    {
      path: '/404',
      name: 'Not found',
      component: resolve => require(['@/components/404'], resolve)
    },
    { path: '*',
      redirect: { path: '/404' }
    },
    {
      path: '/verificationemail',
      name: 'Verification email',
      component: resolve => require(['@/components/utilisateurs/verificationEmail'], resolve),
      meta: {
        forVisitors: true,
        title: 'Verification email',
        metaTags: [
          {
            name: 'description',
            content: 'TENDFOX, le portail indispensable de veille sur les Marchés Publics et Privés en Algérie.'
          },
          {
            property: 'og:description',
            content: 'TENDFOX, le portail indispensable de veille sur les Marchés Publics et Privés en Algérie.'
          }
        ]
      }
    },
    {
      path: '/abonnementeam',
      name: 'abonnementteam',
      component: resolve => require(['@/components/utilisateurs/abonnementTeam'], resolve),
      meta: {
        forAuth: false
      }
    },
    {
      path: '/ficheEntreprise/:id',
      name: 'ficheentreprise',
      component: resolve => require(['@/components/entreprise/ficheEntreprise'], resolve),
      meta: {
        forVisitors: true,
        title: 'Fiche entreprise',
        metaTags: [
          {
            name: 'description',
            content: 'TENDFOX, le portail indispensable de veille sur les Marchés Publics et Privés en Algérie.'
          },
          {
            property: 'og:description',
            content: 'TENDFOX, le portail indispensable de veille sur les Marchés Publics et Privés en Algérie.'
          },
          {
            name: 'robots',
            content: 'index,follow'
          }
        ]
      }
    },
    {
      path: '/ficheappeloffre/:id',
      name: 'ficheappeloffre',
      component: resolve => require(['@/components/appeloffre/ficheappeloffre'], resolve),
      meta: {
        title: 'Fiche Appel d\'offre',
        metaTags: [
          {
            name: 'description',
            content: 'TENDFOX, le portail indispensable de veille sur les Marchés Publics et Privés en Algérie.'
          },
          {
            property: 'og:description',
            content: 'TENDFOX, le portail indispensable de veille sur les Marchés Publics et Privés en Algérie.'
          },
          {
            name: 'robots',
            content: 'index,follow'
          }
        ]
      }
    },
    {
      path: '/document',
      name: 'document',
      component: resolve => require(['@/components/documentUtiles'], resolve),
      meta: {
        forVisitors: true,
        title: 'Document utiles',
        metaTags: [
          {
            name: 'description',
            content: 'L\'ensemble de code des marchés publics, .'
          },
          {
            property: 'og:description',
            content: 'TENDFOX, le portail indispensable de veille sur les Marchés Publics et Privés en Algérie.'
          },
          {
            name: 'robots',
            content: 'index,follow'
          }
        ]
      }
    },
    {
      path: '/password/reset',
      name: 'Renitialiser mot de passe',
      component: resolve => require(['@/components/RecupererMotDePasse'], resolve),
      meta: {
        forVisitors: true,
        title: 'Rénitialiser le mot de passe',
        metaTags: [
          {
            name: 'description',
            content: 'Réinitialisation de mot de passe TENDFOX.'
          },
          {
            property: 'og:description',
            content: 'Réinitialisation de mot de passe TENDFOX.'
          }
        ]
      }
    },
    {
      path: '/tos',
      name: 'Condition',
      component: resolve => require(['@/components/tos'], resolve),
      meta: {
        forVisitors: true,
        title: 'Condition d\'utilisation',
        metaTags: [
          {
            name: 'description',
            content: 'Les présentes Conditions Générales d’utilisation ont pour objet de définir les modalités de mise à disposition des services du site TENDFOX.'
          },
          {
            property: 'og:description',
            content: 'Les présentes Conditions Générales d’utilisation ont pour objet de définir les modalités de mise à disposition des services du site TENDFOX.'
          },
          {
            name: 'robots',
            content: 'index,follow'
          }
        ]
      }
    },
    {
      path: '/onb',
      name: 'Onboarding',
      component: resolve => require(['@/components/utilisateurs/reonboarding'], resolve),
      meta: {
        forAuth: false
      }
    },
    {
      path: '/verifyPhone',
      name: 'Verification automatique telephone',
      component: resolve => require(['@/components/utilisateurs/autoVerificationTelephone'], resolve)
    },
    {
      path: '/smsvalidation',
      name: 'Sms validation',
      component: resolve => require(['@/components/utilisateurs/sms'], resolve),
      meta: {
        forAuth: false
      }
    },
    {
      path: '/emailvalidation',
      name: 'Email validation',
      component: resolve => require(['@/components/utilisateurs/validationEmail'], resolve),
      meta: {
        forVisitors: true
      }
    },
    {
      path: '/confirmemailupdate',
      name: 'Email update confirmation',
      component: resolve => require(['@/components/utilisateurs/confirmEmailUpdate'], resolve),
      meta: {
        forVisitors: true
      }
    },
    {
      path: '/monabonnement',
      name: 'Mon abonnement',
      component: resolve => require(['@/components/utilisateurs/monAbonnement'], resolve),
      meta: {
        forVisitors: true
      }
    }
  /*  {
      path: '/profil/entreprise',
      name: 'Edition de l\'entreprise',
      component: resolve => require(['@/components/utilisateurs/editentreprise'], resolve),
      meta: {
        forAuth: true
      }
    }
    {
      path: '/ficheEntreprise/:id',
      name: 'ficheentreprise',
      component: resolve => require(['@/components/entreprise/ficheEntreprise'], resolve),
      meta: {
        forVisitors: true
      }
    },

    {
      path: '/ficheappeloffre',
      name: 'ficheappeloffre',
      component: resolve => require(['@/components/appeloffre/ficheappeloffre'], resolve),
      meta: {
        forVisitors: true
      }
    },
    {
      path: '/abonnementeam',
      name: 'abonnementteam',
      component: resolve => require(['@/components/utilisateurs/abonnementTeam'], resolve),
      meta: {
        forAuth: false
      }
    },
    {
      path: '/abonnementeamvalidation',
      name: 'abonnementeamvalidation',
      component: resolve => require(['@/components/utilisateurs/validationAbonnementTeam'], resolve),
      meta: {
        forAuth: false
      }
    },
    {
      path: '/emailvalidation',
      name: 'Email validation',
      component: resolve => require(['@/components/utilisateurs/validationEmail'], resolve),
      meta: {
        forVisitors: true
      }
    },
    {
      path: '/updateemail',
      name: 'update-email',
      component: resolve => require(['@/components/utilisateurs/updateEmailValidation'], resolve),
      meta: {
        forVisitors: true
      }
    },
    {
      path: '/renvoiemail',
      name: 'renvoi-email',
      component: resolve => require(['@/components/utilisateurs/renvoiEmail'], resolve),
      meta: {
        forAuth: true
      }
    },
    {
      path: '/smsvalidation',
      name: 'Sms validation',
      component: resolve => require(['@/components/utilisateurs/sms'], resolve),
      meta: {
        forAuth: true
      }
    },
    {
      path: '/updatesms',
      name: 'Sms update',
      component: resolve => require(['@/components/utilisateurs/updateSms'], resolve),
      meta: {
        forAuth: true
      }
    },
    {
      path: '/password/reset',
      name: 'Renitialiser mot de passe',
      component: resolve => require(['@/components/RecupererMotDePasse'], resolve),
      meta: {
        forVisitors: true
      }
    },
    {
      path: '/verificationemail',
      name: 'Verification email',
      component: resolve => require(['@/components/utilisateurs/verificationEmail'], resolve),
      meta: {
        forVisitors: true
      }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: resolve => require(['@/components/contact'], resolve),
      meta: {
        forVisitors: true
      }
    },
    // fin partie public
    // partie connecte
    {
      path: '/profil',
      name: 'Profil',
      component: resolve => require(['@/components/utilisateurs/Profil'], resolve),
      meta: {
        forAuth: true
      }
    },
    {
      path: '/profil/edit',
      name: 'Edition du profil',
      component: resolve => require(['@/components/utilisateurs/editProfil'], resolve),
      meta: {
        forAuth: true
      }
    },
    {
      path: '/profil/entreprise',
      name: 'Edition de l\'entreprise',
      component: resolve => require(['@/components/utilisateurs/editEntreprise'], resolve),
      meta: {
        forAuth: true
      }
    },
    {
      path: '/team',
      name: 'Gestion de la team',
      component: resolve => require(['@/components/utilisateurs/gestionTeam'], resolve),
      meta: {
        forAuth: false,
        forAdminTeam: false
      }
    },
    {
      path: '/404',
      name: 'Not found',
      component: resolve => require(['@/components/404'], resolve)
    },
    { path: '*',
      redirect: { path: '/404' }
    } */
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js